import React, { useEffect, useState } from "react";
import ChatLayout from "../../components/chat/ChatLayout";
import { useAuth } from "../../context/AuthContext";
import { chatAPI } from "../../utils/chatAPI";

function AnalystChat() {
  const { user } = useAuth();
  const [organizationId, setOrganizationId] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOrganizations = async () => {
      if (!user) return;
      try {
        const data = await chatAPI.getAccessibleOrganizations();
        setOrganizations(data);
        const defaultOrg = user.organization || data?.[0]?.id;
        setOrganizationId(defaultOrg || null);
      } catch (err) {
        setOrganizations([]);
      } finally {
        setLoading(false);
      }
    };

    loadOrganizations();
  }, [user]);

  if (loading) {
    return (
      <div className="page-content">
        <div className="card">Loading chat...</div>
      </div>
    );
  }

  if (!organizationId) {
    return (
      <div className="page-content">
        <div className="card">No accessible organization found.</div>
      </div>
    );
  }

  return (
    <div className="page-content">
      {organizations.length > 1 && (
        <div className="card" style={{ marginBottom: "16px" }}>
          <label>Organization</label>
          <select
            value={organizationId}
            onChange={(e) => setOrganizationId(Number(e.target.value))}
          >
            {organizations.map((org) => (
              <option key={org.id} value={org.id}>
                {org.name}
              </option>
            ))}
          </select>
        </div>
      )}
      <ChatLayout organizationId={organizationId} />
    </div>
  );
}

export default AnalystChat;
